module.exports = __webpack_public_path__ + "img/xct.0cfba755.jpg";